"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.number = void 0;
const codes_1 = require("./codes");
const number = (errorText) => {
    return (value, values, texts) => {
        if (typeof value === 'number' && !Number.isNaN(value)) {
            return '';
        }
        if (value && typeof value === 'string' && !Number.isNaN(Number(value))) {
            return '';
        }
        return errorText || texts[codes_1.VALIDATE_CODES.default];
    };
};
exports.number = number;
//# sourceMappingURL=number.js.map